import React from 'react';
import { Labeled, TextField } from 'react-admin';
import { useTranslate } from 'ra-core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import IconFileCopy from '@material-ui/icons/FileCopy';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import ListItem from '@material-ui/core/ListItem';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import classnames from 'classnames';
import { useCopyToClipboard } from '../ui';
const getStatusColor = (classes, status) => {
    switch (status) {
        case 'ENABLED':
            return {
                statusLabel: 'Enabled',
                statusColorClass: classes.enabled,
            };
        case 'DISABLED':
            return {
                statusLabel: 'Disabled',
                statusColorClass: classes.disabled,
            };
        default:
            return {
                statusLabel: 'Disabled',
                statusColorClass: classes.disabled,
            };
    }
};
export const ApplicationDetailsKeyClient = props => {
    const { data, includeSecret } = props;
    const classes = useStyles();
    const translate = useTranslate();
    const copyToClipboard = useCopyToClipboard({
        successMessage: 'resources.applications.notifications.copy_success',
        errorMessage: 'resources.applications.notifications.copy_error',
    });
    if (!data || !data.apiKey) {
        return null;
    }
    const { statusLabel, statusColorClass } = getStatusColor(classes, data.status);
    return (React.createElement(ListItem, { disableGutters: true, dense: true, divider: includeSecret, className: classes.root },
        React.createElement(ExpansionPanel, { className: classes.expansionPanel },
            React.createElement(ExpansionPanelSummary, { className: classes.expansionPanelSummary, expandIcon: React.createElement(ExpandMoreIcon, null), "aria-controls": "panel1a-content", id: "panel1a-header" },
                React.createElement(Typography, { variant: "h3", className: classes.apiKeyName },
                    React.createElement("span", { id: "apiKeyName" }, data.name),
                    React.createElement("span", { className: classnames(classes.status, statusColorClass) }, translate(`resources.applications.status.${statusLabel.toLowerCase()}`)),
                    data.defaultKey && (React.createElement(Chip, { className: classes.chip, label: translate('resources.applications.fields.default') })))),
            React.createElement(ExpansionPanelDetails, { classes: {
                    root: classes.expansionPanelDetails,
                } },
                React.createElement(Grid, { container: true },
                    data.oauthCallbackUrl && (React.createElement(Grid, { item: true, md: 6, sm: 6, xs: 12 },
                        React.createElement(Labeled, { id: "oauthCallbackUrl", label: "resources.applications.fields.callbackUrl", classes: classes, className: classes.fieldLabel },
                            React.createElement("div", { className: classes.fieldValue },
                                React.createElement(TextField, { id: "oauthCallbackUrl", record: data, source: "oauthCallbackUrl" }))))),
                    React.createElement(Grid, { item: true, md: 6, sm: 6, xs: 12 },
                        React.createElement(Labeled
                        // On <Labeled />, this will translate in a correct `for` attribute on the label
                        , { 
                            // On <Labeled />, this will translate in a correct `for` attribute on the label
                            id: "apiKeyClientID", label: 'resources.applications.fields.apiKeyClientID', classes: classes, className: classes.fieldLabel },
                            React.createElement(Typography, { variant: "body2", className: classes.fieldContent },
                                React.createElement("span", { id: "apiKeyClientID", className: classes.fieldValue }, data.apiKey),
                                React.createElement(IconButton, { className: classes.buttonCopy, color: "primary", title: translate('resources.applications.notifications.copy_to_clipboard'), value: data.apiKey, onClick: copyToClipboard },
                                    React.createElement(IconFileCopy, { className: classes.iconCopy })))))),
                React.createElement(Grid, { container: true },
                    data.oauthScope && (React.createElement(Grid, { item: true, md: 6, sm: 6, xs: 12 },
                        React.createElement(Labeled
                        // On <Labeled />, this will translate in a correct `for` attribute on the label
                        , { 
                            // On <Labeled />, this will translate in a correct `for` attribute on the label
                            id: "oauthScope", label: "resources.applications.fields.scope", classes: classes, className: classes.fieldLabel },
                            React.createElement("div", { className: classes.fieldValue },
                                React.createElement(TextField, { id: "oauthScope", record: data, source: "oauthScope" }))))),
                    includeSecret && (React.createElement(Grid, { item: true, md: 6, sm: 6, xs: 12 },
                        React.createElement(Labeled
                        // on Labeled, this will translate in a correct `for` attribute on the label
                        , { 
                            // on Labeled, this will translate in a correct `for` attribute on the label
                            id: "sharedSecretClientSecret", label: "resources.applications.fields.sharedSecretClientSecret", classes: classes, className: classes.fieldLabel },
                            React.createElement(Typography, { variant: "body2", className: classes.fieldContent },
                                React.createElement("span", { id: "sharedSecretClientSecret", className: classes.fieldValue }, data.keySecret),
                                data.keySecret &&
                                    !data.keySecret.includes('****') && (React.createElement(IconButton, { className: classes.buttonCopy, color: "primary", title: translate('resources.applications.notifications.copy_to_clipboard'), value: data.keySecret, onClick: copyToClipboard },
                                    React.createElement(IconFileCopy, { className: classes.iconCopy })))))))),
                React.createElement(Grid, null, data.oauthType && (React.createElement(Grid, { item: true, md: 6, sm: 6, xs: 12 },
                    React.createElement(Labeled
                    // On <Labeled />, this will translate in a correct `for` attribute on the label
                    , { 
                        // On <Labeled />, this will translate in a correct `for` attribute on the label
                        id: "oauthType", label: "resources.applications.fields.type", classes: classes, className: classes.fieldLabel },
                        React.createElement("div", { className: classes.fieldValue },
                            React.createElement(TextField, { id: "oauthType", record: data, source: "oauthType" }))))))))));
};
const useStyles = makeStyles(theme => ({
    root: {
        display: 'list-item',
    },
    status: {
        fontSize: '14px',
        marginLeft: theme.spacing(2),
        '&:before': {
            borderRadius: '10px',
            content: '""',
            display: 'inline-block',
            height: '10px',
            marginTop: '-6px',
            marginRight: theme.spacing(1),
            top: '50%',
            width: '10px',
        },
    },
    enabled: {
        color: '#4CAF50',
        '&:before': {
            backgroundColor: '#4CAF50',
        },
    },
    disabled: {
        color: '#696969',
        '&:before': {
            backgroundColor: '#696969',
        },
    },
    expansionPanel: {
        boxShadow: 'none',
    },
    expansionPanelSummary: {
        '& > div': {
            margin: `${theme.spacing(1)}px 0 !important`,
        },
    },
    fieldLabel: {
        margin: `0 ${theme.spacing(1)}px ${theme.spacing(1)}px`,
        minWidth: '100px',
    },
    chip: {
        marginLeft: theme.spacing(2),
        height: '21px',
    },
    expandCollapseButton: {
        color: theme.palette.primary.main,
        float: 'right',
    },
    expansionPanelDetails: {
        display: 'block',
        padding: `0 ${theme.spacing(1)}px`,
    },
    fieldContent: {},
    fieldValue: {
        color: theme.palette.primary.textHub || '#333333',
        fontFamily: theme.typography.textHub,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '20px',
    },
    buttonCopy: {
        padding: 0,
        marginLeft: '10px',
    },
    iconCopy: {
        fontSize: '14px',
        color: theme.palette.secondary.main,
    },
    label: {
        color: theme.palette.primary.textHub || '#333333',
        fontFamily: theme.typography.textHub,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 'bold',
        lineHeight: '22px',
        transform: 'unset',
    },
    apiKeyName: {
        color: theme.palette.primary.main,
        fontFamily: theme.typography.apiHubFont,
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '22px',
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        textTransform: 'none',
    },
}), {
    name: 'Layer7ApplicationKeyClient',
});
//# sourceMappingURL=ApplicationDetailsKeyClient.js.map